// Project CRUD wrappers + multi-file run helpers.
import { BACKEND_URL } from "./api";

function url(p) { return `${BACKEND_URL}${p}`; }

async function jsonOrThrow(res) {
  let body = null;
  try { body = await res.json(); } catch (_) { /* */ }
  if (!res.ok) {
    const err = new Error(
      (body && (body.detail?.message || body.detail?.error || body.detail || body.error)) ||
      `HTTP ${res.status}`
    );
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function listProjects(limit = 50, skip = 0) {
  const res = await fetch(url(`/api/projects?limit=${limit}&skip=${skip}`));
  return jsonOrThrow(res);
}

export async function getProject(id) {
  const res = await fetch(url(`/api/projects/${encodeURIComponent(id)}`));
  return jsonOrThrow(res);
}

export async function createProject({ name, language, code, files, entry_file }) {
  const res = await fetch(url("/api/projects"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, language, code, files: files || null, entry_file: entry_file || null }),
  });
  return jsonOrThrow(res);
}

export async function updateProject(id, patch) {
  const res = await fetch(url(`/api/projects/${encodeURIComponent(id)}`), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  return jsonOrThrow(res);
}

export async function deleteProject(id) {
  const res = await fetch(url(`/api/projects/${encodeURIComponent(id)}`), {
    method: "DELETE",
  });
  if (res.status === 204) return true;
  return jsonOrThrow(res);
}

export async function duplicateProject(id) {
  const res = await fetch(url(`/api/projects/${encodeURIComponent(id)}/duplicate`), {
    method: "POST",
  });
  return jsonOrThrow(res);
}

export async function runWebFiles(files) {
  const res = await fetch(url("/api/run-web"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ files }),
  });
  return jsonOrThrow(res);
}
